import type { IconKey } from "./ClueImages";

export type PictureQuestion = {
    type: "picture";
    answer: string;
    icons: string[];
    iconLabels: string[];
    clues: string[];
    clueLabels: string[];
    imageKeys: [IconKey, IconKey];
    options: string[];
    explanation: string;
};

export type FillQuestion = {
    type: "fill";
    answer: string;
    pattern: string[];
    pool: string[];
    explanation: string;
};

export type IdiomQuestion = PictureQuestion | FillQuestion;

type QuestionSeed = {
    answer: string;
    clues: string[];
    clueLabels: string[];
    explanation: string;
};

const SEEDS: QuestionSeed[] = [
    { answer: "龙马精神", clues: ["骏马", "神龙"], clueLabels: ["马", "龙"], explanation: "比喻人精神旺盛、奋发向上。" },
    { answer: "一举两得", clues: ["一次行动", "两个收获"], clueLabels: ["一举", "两得"], explanation: "做一件事，同时得到两方面的好处。" },
    { answer: "画蛇添足", clues: ["画蛇", "加脚"], clueLabels: ["蛇", "足"], explanation: "比喻做了多余的事，反而把事情弄坏。" },
    { answer: "四面八方", clues: ["四面", "八方"], clueLabels: ["四面", "八方"], explanation: "泛指周围各地或各个方面。" },
    { answer: "守株待兔", clues: ["树桩", "兔子"], clueLabels: ["守株", "待兔"], explanation: "比喻不主动努力，只想靠侥幸获得成功。" },
    { answer: "七上八下", clues: ["七上", "八下"], clueLabels: ["七", "八"], explanation: "形容心里慌乱不安。" },
    { answer: "狐假虎威", clues: ["狐狸", "老虎"], clueLabels: ["狐", "虎"], explanation: "比喻倚仗别人的势力来欺压人。" },
    { answer: "九牛一毛", clues: ["九头牛", "一根毛"], clueLabels: ["九牛", "一毛"], explanation: "比喻极大数量中微不足道的一部分。" },
    { answer: "亡羊补牢", clues: ["丢羊", "修牢"], clueLabels: ["亡羊", "补牢"], explanation: "出了问题后及时补救，仍可避免继续受损。" },
    { answer: "三心二意", clues: ["三颗心", "两种想法"], clueLabels: ["三心", "二意"], explanation: "形容意志不坚定，做事不专心。" },
    { answer: "对牛弹琴", clues: ["黄牛", "弹琴"], clueLabels: ["牛", "琴"], explanation: "比喻对不懂道理的人讲道理，白费口舌。" },
    { answer: "五湖四海", clues: ["湖泊", "大海"], clueLabels: ["五湖", "四海"], explanation: "指全国各地或世界各地。" },
    { answer: "杯弓蛇影", clues: ["酒杯", "蛇影"], clueLabels: ["杯", "蛇影"], explanation: "比喻疑神疑鬼，自相惊扰。" },
    { answer: "惊弓之鸟", clues: ["弓箭", "飞鸟"], clueLabels: ["弓", "鸟"], explanation: "比喻受过惊吓后遇事就害怕的人。" },
    { answer: "掩耳盗铃", clues: ["捂耳", "偷铃"], clueLabels: ["耳", "铃"], explanation: "比喻自己欺骗自己。" },
    { answer: "刻舟求剑", clues: ["小船", "宝剑"], clueLabels: ["舟", "剑"], explanation: "比喻拘泥成法，不懂得随情况变化。" },
    { answer: "滥竽充数", clues: ["吹竽", "混入队伍"], clueLabels: ["竽", "数"], explanation: "比喻没有真本领的人混在行家里充数。" },
    { answer: "买椟还珠", clues: ["盒子", "珍珠"], clueLabels: ["椟", "珠"], explanation: "比喻取舍不当，抓了次要的丢了主要的。" },
    { answer: "盲人摸象", clues: ["盲人", "大象"], clueLabels: ["盲人", "象"], explanation: "比喻只了解局部就片面判断整体。" },
    { answer: "井底之蛙", clues: ["井底", "青蛙"], clueLabels: ["井", "蛙"], explanation: "比喻见识狭窄的人。" },
    { answer: "鹤立鸡群", clues: ["白鹤", "鸡群"], clueLabels: ["鹤", "鸡群"], explanation: "比喻才能或仪表在众人中很突出。" },
    { answer: "雪中送炭", clues: ["大雪", "炭火"], clueLabels: ["雪", "炭"], explanation: "比喻在别人急需时给予帮助。" },
    { answer: "锦上添花", clues: ["锦缎", "鲜花"], clueLabels: ["锦", "花"], explanation: "比喻使美好的事物更加美好。" },
    { answer: "画龙点睛", clues: ["画龙", "点眼"], clueLabels: ["龙", "睛"], explanation: "比喻关键处一笔使内容更传神。" },
    { answer: "纸上谈兵", clues: ["纸张", "兵法"], clueLabels: ["纸", "兵"], explanation: "比喻只会空谈理论，不能解决实际问题。" },
    { answer: "胸有成竹", clues: ["心中", "竹子"], clueLabels: ["胸", "竹"], explanation: "比喻做事前已有成熟打算。" },
    { answer: "水滴石穿", clues: ["水滴", "石头"], clueLabels: ["水", "石"], explanation: "比喻坚持不懈就能做成难事。" },
    { answer: "叶公好龙", clues: ["叶公", "真龙"], clueLabels: ["叶公", "龙"], explanation: "比喻表面爱好，实际并不真正喜欢。" },
    { answer: "愚公移山", clues: ["老人", "大山"], clueLabels: ["愚公", "山"], explanation: "比喻坚持不懈地克服困难。" },
    { answer: "精卫填海", clues: ["小鸟", "大海"], clueLabels: ["精卫", "海"], explanation: "比喻意志坚决，不畏艰难。" },
    { answer: "南辕北辙", clues: ["向南", "向北"], clueLabels: ["南", "北"], explanation: "比喻行动和目的正好相反。" },
    { answer: "走马观花", clues: ["骑马", "看花"], clueLabels: ["马", "花"], explanation: "比喻粗略地观察事物。" },
    { answer: "揠苗助长", clues: ["拔苗", "长高"], clueLabels: ["苗", "长"], explanation: "比喻违反规律，急于求成反而坏事。" },
    { answer: "青出于蓝", clues: ["青色", "蓝草"], clueLabels: ["青", "蓝"], explanation: "比喻学生超过老师，后人胜过前人。" },
    { answer: "指鹿为马", clues: ["鹿", "马"], clueLabels: ["鹿", "马"], explanation: "比喻故意颠倒是非。" },
    { answer: "猴子捞月", clues: ["猴子", "月亮"], clueLabels: ["猴", "月"], explanation: "比喻白费力气，事情无法办到。" },
    { answer: "闻鸡起舞", clues: ["鸡鸣", "起舞"], clueLabels: ["鸡", "舞"], explanation: "比喻有志之士及时奋发努力。" },
    { answer: "草船借箭", clues: ["草船", "箭雨"], clueLabels: ["船", "箭"], explanation: "比喻运用智慧借助外力达到目的。" },
    { answer: "破釜沉舟", clues: ["破锅", "沉船"], clueLabels: ["釜", "舟"], explanation: "比喻下定决心，不留退路。" },
    { answer: "望梅止渴", clues: ["梅子", "口渴"], clueLabels: ["梅", "渴"], explanation: "比喻用空想或假象安慰自己。" },
    { answer: "画饼充饥", clues: ["画饼", "饥饿"], clueLabels: ["饼", "饥"], explanation: "比喻用空想来安慰自己。" },
    { answer: "拔苗助长", clues: ["拔苗", "长高"], clueLabels: ["苗", "助长"], explanation: "比喻急于求成，反而把事情弄坏。" },
    { answer: "百发百中", clues: ["一百箭", "全命中"], clueLabels: ["百发", "百中"], explanation: "形容射箭或做事准确无误。" },
    { answer: "半途而废", clues: ["半路", "放弃"], clueLabels: ["半途", "废"], explanation: "比喻事情没做完就停止。" },
    { answer: "背水一战", clues: ["背后有水", "决战"], clueLabels: ["背水", "一战"], explanation: "比喻在绝境中拼死一搏。" },
    { answer: "闭门造车", clues: ["关门", "造车"], clueLabels: ["闭门", "车"], explanation: "比喻不考虑实际情况，主观办事。" },
    { answer: "别开生面", clues: ["新门", "新面貌"], clueLabels: ["别开", "生面"], explanation: "比喻另创新的形式或局面。" },
    { answer: "兵贵神速", clues: ["士兵", "很快"], clueLabels: ["兵", "速"], explanation: "用兵贵在行动特别迅速。" },
    { answer: "不耻下问", clues: ["虚心", "请教"], clueLabels: ["下问", "不耻"], explanation: "形容虚心向地位或学问不如自己的人请教。" },
    { answer: "不可救药", clues: ["病重", "药无效"], clueLabels: ["救", "药"], explanation: "比喻坏到无法挽救。" },
    { answer: "不劳而获", clues: ["不劳动", "有收获"], clueLabels: ["不劳", "获"], explanation: "自己不劳动却占有别人的劳动成果。" },
    { answer: "不速之客", clues: ["未邀请", "客人"], clueLabels: ["不速", "客"], explanation: "指没有邀请而自己来的客人。" },
    { answer: "沧海一粟", clues: ["大海", "一粒米"], clueLabels: ["海", "粟"], explanation: "比喻非常渺小。" },
    { answer: "车水马龙", clues: ["车流", "马队"], clueLabels: ["车", "马"], explanation: "形容热闹繁华，来往不断。" },
    { answer: "乘风破浪", clues: ["大风", "破浪"], clueLabels: ["风", "浪"], explanation: "比喻志向远大，不怕困难。" },
    { answer: "出奇制胜", clues: ["奇招", "胜利"], clueLabels: ["奇", "胜"], explanation: "用出人意料的方法取胜。" },
    { answer: "唇亡齿寒", clues: ["嘴唇", "牙齿"], clueLabels: ["唇", "齿"], explanation: "比喻关系密切，利害相关。" },
    { answer: "打草惊蛇", clues: ["打草", "蛇惊"], clueLabels: ["草", "蛇"], explanation: "比喻行动不慎使对方警觉。" },
    { answer: "大材小用", clues: ["大木材", "小用途"], clueLabels: ["大材", "小用"], explanation: "比喻人才使用不当，屈才。" },
    { answer: "胆小如鼠", clues: ["胆小", "老鼠"], clueLabels: ["胆", "鼠"], explanation: "形容非常胆小。" },
    { answer: "东山再起", clues: ["东山", "再起"], clueLabels: ["东山", "起"], explanation: "比喻失势后重新恢复地位。" },
    { answer: "东张西望", clues: ["看东边", "望西边"], clueLabels: ["东", "西"], explanation: "形容到处张望。" },
    { answer: "独木难支", clues: ["一根木头", "支撑"], clueLabels: ["独木", "难支"], explanation: "比喻一个人的力量难以支撑全局。" },
    { answer: "废寝忘食", clues: ["不睡", "忘吃"], clueLabels: ["寝", "食"], explanation: "形容专心努力。" },
    { answer: "风吹草动", clues: ["风吹", "草动"], clueLabels: ["风", "草"], explanation: "比喻轻微的动静或变化。" },
    { answer: "风雨同舟", clues: ["风雨", "同船"], clueLabels: ["风雨", "舟"], explanation: "比喻共同经历困难。" },
    { answer: "高山流水", clues: ["高山", "流水"], clueLabels: ["山", "水"], explanation: "比喻知音或美妙乐曲。" },
    { answer: "功亏一篑", clues: ["工程", "一筐土"], clueLabels: ["功", "篑"], explanation: "比喻只差最后一点而失败。" },
    { answer: "瓜田李下", clues: ["瓜田", "李树"], clueLabels: ["瓜", "李"], explanation: "比喻容易引起嫌疑的地方。" },
    { answer: "海底捞针", clues: ["海底", "针"], clueLabels: ["海", "针"], explanation: "比喻极难寻找。" },
    { answer: "邯郸学步", clues: ["邯郸", "学走路"], clueLabels: ["学", "步"], explanation: "比喻模仿不成，反把原来的本领忘了。" },
    { answer: "汗牛充栋", clues: ["牛拉书", "满屋书"], clueLabels: ["牛", "栋"], explanation: "形容藏书非常多。" },
    { answer: "好高骛远", clues: ["高处", "远方"], clueLabels: ["高", "远"], explanation: "比喻不切实际地追求过高目标。" },
    { answer: "后来居上", clues: ["后来者", "超过"], clueLabels: ["后来", "居上"], explanation: "后来的超过先前的。" },
    { answer: "虎头蛇尾", clues: ["虎头", "蛇尾"], clueLabels: ["虎", "蛇"], explanation: "比喻开始声势大，后来劲头小。" },
    { answer: "囫囵吞枣", clues: ["整颗枣", "吞下"], clueLabels: ["吞", "枣"], explanation: "比喻学习不加分析地笼统接受。" },
    { answer: "花言巧语", clues: ["花", "巧话"], clueLabels: ["花言", "巧语"], explanation: "指虚假而动听的话。" },
    { answer: "画地为牢", clues: ["画圈", "当牢"], clueLabels: ["地", "牢"], explanation: "比喻只许在限定范围内活动。" },
    { answer: "火上浇油", clues: ["火焰", "倒油"], clueLabels: ["火", "油"], explanation: "比喻使人更加愤怒或事态更严重。" },
    { answer: "鸡犬不宁", clues: ["鸡", "狗"], clueLabels: ["鸡", "犬"], explanation: "形容骚扰得很厉害，连鸡狗都不得安宁。" },
    { answer: "家喻户晓", clues: ["每家", "都知道"], clueLabels: ["家", "户"], explanation: "形容人人都知道。" },
    { answer: "见缝插针", clues: ["缝隙", "插针"], clueLabels: ["缝", "针"], explanation: "比喻尽量利用一切可利用的空间或时间。" },
    { answer: "脚踏实地", clues: ["双脚", "地面"], clueLabels: ["脚", "地"], explanation: "形容做事踏实认真。" },
    { answer: "金鸡独立", clues: ["金鸡", "单脚站"], clueLabels: ["鸡", "立"], explanation: "指一只脚站立的姿势。" },
    { answer: "开门见山", clues: ["开门", "见山"], clueLabels: ["门", "山"], explanation: "比喻说话写文章直截了当。" },
    { answer: "口是心非", clues: ["嘴上说", "心里想"], clueLabels: ["口", "心"], explanation: "嘴上说的是一套，心里想的是另一套。" },
    { answer: "苦尽甘来", clues: ["苦味", "甜味"], clueLabels: ["苦", "甘"], explanation: "艰苦的日子过去，美好的日子来到。" },
    { answer: "狼吞虎咽", clues: ["狼", "虎"], clueLabels: ["狼", "虎"], explanation: "形容吃东西又急又猛。" },
    { answer: "老马识途", clues: ["老马", "道路"], clueLabels: ["马", "途"], explanation: "比喻有经验的人熟悉情况。" },
    { answer: "力不从心", clues: ["力气", "心愿"], clueLabels: ["力", "心"], explanation: "心里想做，力量却达不到。" },
    { answer: "柳暗花明", clues: ["柳树", "鲜花"], clueLabels: ["柳", "花"], explanation: "比喻困境后出现新的转机。" },
    { answer: "马到成功", clues: ["骏马", "成功"], clueLabels: ["马", "成功"], explanation: "形容事情一开始就顺利成功。" },
    { answer: "买空卖空", clues: ["买", "卖"], clueLabels: ["买空", "卖空"], explanation: "比喻投机取巧的行为。" },
    { answer: "门庭若市", clues: ["门口", "集市"], clueLabels: ["门庭", "市"], explanation: "形容来的人很多，非常热闹。" },
    { answer: "妙笔生花", clues: ["妙笔", "花朵"], clueLabels: ["笔", "花"], explanation: "比喻杰出的写作才能。" },
    { answer: "名落孙山", clues: ["名单", "孙山"], clueLabels: ["名", "孙山"], explanation: "指考试或选拔没有被录取。" },
    { answer: "目不识丁", clues: ["眼睛", "丁字"], clueLabels: ["目", "丁"], explanation: "形容人不识字。" },
    { answer: "鸟语花香", clues: ["小鸟", "花香"], clueLabels: ["鸟", "花"], explanation: "形容春天美好的景象。" },
    { answer: "披星戴月", clues: ["星星", "月亮"], clueLabels: ["星", "月"], explanation: "形容早出晚归，辛勤奔波。" },
    { answer: "旗开得胜", clues: ["旗帜", "胜利"], clueLabels: ["旗", "胜"], explanation: "比喻事情一开始就取得好成绩。" },
];

// Every level owns an explicit pair of illustrations. Keep this list in the
// same order as SEEDS so a question can never fall back to an unrelated icon.
const QUESTION_IMAGE_KEYS: [IconKey, IconKey][] = [
    ["horse", "dragon"],       // 1  龙马精神
    ["one_action", "two_rewards"], // 2  一举两得
    ["snake", "foot"],         // 3  画蛇添足
    ["compass4", "compass8"],  // 4  四面八方
    ["stump", "rabbit"],       // 5  守株待兔
    ["up7", "down8"],          // 6  七上八下
    ["fox", "tiger"],          // 7  狐假虎威
    ["ox", "hair"],            // 8  九牛一毛
    ["sheep", "fence"],        // 9  亡羊补牢
    ["heart", "thoughts"],     // 10 三心二意
    ["ox", "guqin"],           // 11 对牛弹琴
    ["five_lakes", "four_seas"], // 12 五湖四海
    ["cup", "snake"],          // 13 杯弓蛇影
    ["bow", "crane"],          // 14 惊弓之鸟
    ["ear", "bell"],           // 15 掩耳盗铃
    ["boat", "sword"],         // 16 刻舟求剑
    ["sheng", "sheng_group"],  // 17 滥竽充数
    ["box", "pearl"],          // 18 买椟还珠
    ["blindfold", "elephant"], // 19 盲人摸象
    ["well", "frog"],          // 20 井底之蛙
    ["crane", "rooster"],      // 21 鹤立鸡群
    ["snow", "charcoal"],      // 22 雪中送炭
    ["silk", "flower"],        // 23 锦上添花
    ["dragon", "eye"],         // 24 画龙点睛
    ["paper", "sword"],        // 25 纸上谈兵
    ["bamboo_plan", "bamboo"], // 26 胸有成竹
    ["water", "stone"],        // 27 水滴石穿
    ["scholar", "dragon"],     // 28 叶公好龙
    ["old_man", "mountain"],   // 29 愚公移山
    ["jingwei", "sea"],        // 30 精卫填海
    ["south", "north"],        // 31 南辕北辙
    ["horse", "flower"],       // 32 走马观花
    ["plant", "up7"],          // 33 揠苗助长
    ["green_dye", "blue_dye"], // 34 青出于蓝
    ["deer", "horse"],         // 35 指鹿为马
    ["monkey", "moon"],        // 36 猴子捞月
    ["rooster", "dance"],      // 37 闻鸡起舞
    ["boat", "bow"],           // 38 草船借箭
    ["broken_cauldron", "boat"], // 39 破釜沉舟
    ["plum", "water"],         // 40 望梅止渴
    ["cake", "eat"],           // 41 画饼充饥
    ["plant", "up7"],          // 42 拔苗助长
    ["archer", "trophy"],      // 43 百发百中
    ["road", "down8"],         // 44 半途而废
    ["water", "fight"],        // 45 背水一战
    ["door", "cart"],          // 46 闭门造车
    ["door", "new_scene"],     // 47 别开生面
    ["sword", "run"],          // 48 兵贵神速
    ["scholar", "humble_question"], // 49 不耻下问
    ["medicine", "medicine_no_effect"], // 50 不可救药
    ["sleep", "coins"],        // 51 不劳而获
    ["door", "guest"],         // 52 不速之客
    ["sea", "rice"],           // 53 沧海一粟
    ["cart", "horse"],         // 54 车水马龙
    ["wind", "sea"],           // 55 乘风破浪
    ["sword", "trophy"],       // 56 出奇制胜
    ["lips", "teeth"],         // 57 唇亡齿寒
    ["bamboo", "snake"],       // 58 打草惊蛇
    ["stump", "hand"],         // 59 大材小用
    ["heart", "mouse"],        // 60 胆小如鼠
    ["mountain", "run"],       // 61 东山再起
    ["compass4", "eye"],       // 62 东张西望
    ["stump", "lift"],         // 63 独木难支
    ["sleep", "eat"],          // 64 废寝忘食
    ["wind", "bamboo"],        // 65 风吹草动
    ["rain", "boat"],          // 66 风雨同舟
    ["mountain", "water"],     // 67 高山流水
    ["farmer", "soil_basket"], // 68 功亏一篑
    ["melon", "plum"],         // 69 瓜田李下
    ["sea", "needle"],         // 70 海底捞针
    ["scholar", "walk"],       // 71 邯郸学步
    ["ox", "books"],           // 72 汗牛充栋
    ["mountain", "road"],      // 73 好高骛远
    ["guest", "up7"],          // 74 后来居上
    ["tiger", "snake"],        // 75 虎头蛇尾
    ["date", "eat"],           // 76 囫囵吞枣
    ["flower", "talk"],        // 77 花言巧语
    ["paint", "fence"],        // 78 画地为牢
    ["fire", "oil"],           // 79 火上浇油
    ["rooster", "dog"],        // 80 鸡犬不宁
    ["house", "talk"],         // 81 家喻户晓
    ["fence", "needle"],       // 82 见缝插针
    ["foot", "road"],          // 83 脚踏实地
    ["rooster", "foot"],       // 84 金鸡独立
    ["door", "mountain"],      // 85 开门见山
    ["lips", "heart"],         // 86 口是心非
    ["medicine", "candy"],     // 87 苦尽甘来
    ["fox", "tiger"],          // 88 狼吞虎咽
    ["horse", "road"],         // 89 老马识途
    ["lift", "heart"],         // 90 力不从心
    ["stump", "flower"],       // 91 柳暗花明
    ["horse", "trophy"],       // 92 马到成功
    ["coins", "market"],       // 93 买空卖空
    ["door", "market"],        // 94 门庭若市
    ["paint", "flower"],       // 95 妙笔生花
    ["paper", "scholar"],      // 96 名落孙山
    ["eye", "books"],          // 97 目不识丁
    ["crane", "flower"],       // 98 鸟语花香
    ["star", "moon"],          // 99 披星戴月
    ["flag", "trophy"],        // 100 旗开得胜
];

if (QUESTION_IMAGE_KEYS.length !== SEEDS.length) {
    throw new Error(`题目图片配置数量错误：${QUESTION_IMAGE_KEYS.length}/${SEEDS.length}`);
}

const ALL_ANSWERS = SEEDS.map(item => item.answer);

export const QUESTIONS: PictureQuestion[] = SEEDS.map((seed, index) => createPictureQuestion(seed, index + 1));

export function questionForLevel(level: number): PictureQuestion {
    const safeLevel = Math.max(1, Math.min(100, Math.floor(level || 1)));
    return createPictureQuestion(SEEDS[safeLevel - 1], safeLevel);
}

export function totalQuestions(): number {
    return SEEDS.length;
}

function createPictureQuestion(seed: QuestionSeed, level: number): PictureQuestion {
    return {
        type: "picture",
        answer: seed.answer,
        icons: seed.clues,
        iconLabels: seed.clueLabels,
        clues: seed.clues,
        clueLabels: seed.clueLabels,
        imageKeys: QUESTION_IMAGE_KEYS[level - 1],
        options: buildOptions(seed.answer, level),
        explanation: seed.explanation,
    };
}

function buildOptions(answer: string, seed: number): string[] {
    const options = [answer];
    let cursor = seed * 7;
    while (options.length < 4) {
        const candidate = ALL_ANSWERS[cursor % ALL_ANSWERS.length];
        if (options.indexOf(candidate) < 0) options.push(candidate);
        cursor += 11;
    }
    return shuffle(options, seed);
}

function shuffle<T>(items: T[], seed: number): T[] {
    const result = [...items];
    let state = seed || 1;
    for (let i = result.length - 1; i > 0; i--) {
        state = (state * 9301 + 49297) % 233280;
        const j = state % (i + 1);
        [result[i], result[j]] = [result[j], result[i]];
    }
    return result;
}
